import React, { PureComponent } from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

class JoinAccountPage extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
    }

    render() {
        const { verifiedUser } = this.props;

        var url = new URL(window.location.href)
        console.log("url " + url)
        var email = url.searchParams.get("email")
        console.log("email " + email)
        var account = url.searchParams.get("account")
        console.log("account " + account)
        var accountRole = url.searchParams.get("account-role")
        console.log("accountRole " + accountRole)
        var error = url.searchParams.get("error")
        console.log("error " + error)

        var joinAccountMsg
        if (error === '0') {
            joinAccountMsg = <FormattedMessage id="joinAccount.joinSuccess" values={{ email: email, account: account, role: accountRole }} />
        } else if (error === '1') {
            joinAccountMsg = <FormattedMessage id="joinAccount.joinFail" values={{ email: email }} />
        }

        if (verifiedUser === false) {
            return <Navigate to="/cloak/verify-email" />
        }

        return (
            <div className="clk-primary-join-div">
                <div className="clk-primary-join clk-box-shadow ">
                    <div className="clk-login-div">
                        <div className="clk-main-title-div">
                            <div className="clk-main-title-text">
                                <FormattedMessage id="joinAccount.title" />
                            </div>
                        </div>
                        <div className='clk-primary-button-div' style={{ marginTop: 48, marginLeft: 15, marginRight: 15 }}>
                            {joinAccountMsg}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        verifiedUser: state.auth.verifiedUser,
    }
};

export default connect(mapStateToProps)(JoinAccountPage);
